import nBossConnection from 'modules/base/service/nBossConnection';

class OpcDaWriterLogService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'opcDaWriterLogControl';
	}

	/**
	 * @return {Promise<NamedDto[]>}
	 */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new OpcDaWriterLogService();